import { render, staticRenderFns } from "./lineupBoard.vue?vue&type=template&id=0b81ca3c&scoped=true&"
import script from "./lineupBoard.vue?vue&type=script&lang=js&"
export * from "./lineupBoard.vue?vue&type=script&lang=js&"
import style0 from "./lineupBoard.vue?vue&type=style&index=0&id=0b81ca3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b81ca3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\atmolab_server_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b81ca3c')) {
      api.createRecord('0b81ca3c', component.options)
    } else {
      api.reload('0b81ca3c', component.options)
    }
    module.hot.accept("./lineupBoard.vue?vue&type=template&id=0b81ca3c&scoped=true&", function () {
      api.rerender('0b81ca3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/coachmanage/teammanage/component/lineupBoard.vue"
export default component.exports